import { ImageOff } from 'lucide-react'

interface DraftHeroImageProps {
  url: string | null
  alt: string | null
}

export function DraftHeroImage({ url, alt }: DraftHeroImageProps) {
  if (!url) {
    return (
      <div
        className="aspect-video bg-muted rounded-lg flex items-center justify-center"
        aria-label="No hero image"
      >
        <ImageOff className="size-12 text-muted-foreground/40" />
      </div>
    )
  }

  return (
    <div className="aspect-video rounded-lg overflow-hidden">
      <img
        src={url}
        alt={alt ?? 'Hero image'}
        className="w-full h-full object-cover"
      />
    </div>
  )
}
